import { render, staticRenderFns } from "./Publishing.vue?vue&type=template&id=485993de"
import script from "./Publishing.vue?vue&type=script&lang=js"
export * from "./Publishing.vue?vue&type=script&lang=js"
import style0 from "./Publishing.vue?vue&type=style&index=0&id=485993de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports